import "./App.css";
import { BrowserRouter, Route } from "react-router-dom";
import Header from "./Components/Header";
import HomePage from "./Pages/HomePage";
import CoinPage from "./Pages/CoinPage";
import { makeStyles } from "@mui/material";
import { getColors } from "./theme";
import getColorsHook from "./getColorsHook";



function App() {

  const [colors] = getColorsHook();

  const style = {
    app: {
      backgroundColor: colors.bg1,
      color: colors.text2,
      minHeight: "100vh",
    },
  };

  return (
    <BrowserRouter>
      <div  style={style.app}>
        {/* <div className={classes.App}> */}
        <div>
          <Header />
        </div>
        <Route path="/" component={HomePage} exact />
        <Route path="/coin/:id" component={CoinPage} />
      </div>
    </BrowserRouter>
  );
}

export default App;
